import { onboardingQuery } from "@healthos/client-data";
import { useQuery } from "@tanstack/react-query";
import { client } from "../api/healthos";

/**
 * The member's onboarding row. Every web reader goes through here so they
 * share one key, one fetcher and one freshness window; a reader with its own
 * shorter window refetches the row on every mount.
 */
export function useOnboardingQuery(options: { enabled?: boolean } = {}) {
  return useQuery({ ...onboardingQuery(client()), enabled: options.enabled ?? true });
}
